import $ from "jquery";

function format(input, pattern) {
	var i = 0, j = 0;
	var result = "";
	var exactMatch = false;
	while(j < pattern.length) {
		var chPattern = pattern.charAt(j++);
		if(chPattern == '\\') {
			exactMatch = true;
			continue;
		}
		var chInput = i < input.length ? input.charAt(i++) : "";
		if(chInput == ' ' && chPattern != ' ') {
			j--; // hold pattern
			continue;
		}
		if(!exactMatch) {
			switch(chPattern) {
				case 'A': // uppercase, or convert
					if(chInput >= 'A' && chInput <= 'Z' || chInput >= 'a' && chInput <= 'z') {
						result += chInput.toUpperCase();
						continue;
					}
					return null;
				case 'a': // lowercase, or convert
					if(chInput >= 'a' && chInput <= 'z' || chInput >= 'A' && chInput <= 'Z') {
						result += chInput.toLowerCase();
						continue;
					}
					return null;
				case 'Z': // any case letter
				case 'z':
					if(chInput >= 'A' && chInput <= 'Z' || chInput >= 'a' && chInput <= 'z') {
						result += chInput;
						continue;
					}
					return null;
				case '0': // digit
				case '#':
					if(chInput >= '0' && chInput <= '9') {
						result += chInput;
						continue;
					}
					return null;
				case '?': // letter or digit
					if(chInput >= 'A' && chInput <= 'Z' || chInput >= 'a' && chInput <= 'z' || chInput >= '0' && chInput <= '9') {
						result += chInput;
						continue;
					}
					return null;
				case '*': // anything
					if(chInput != "") {
						result += chInput;
						continue;
					}
					return null;
			}
		}
		result += chPattern;
		if(chInput != "" && chInput != chPattern) // hold the char
			i--;
		else
			exactMatch = false;
	}
	return i == input.length && j == pattern.length ? result : null;
}

$.fn.patInput = function () {
	return this.each(function () {
		// set it directly to have first chance
		this.onchange = function () {
			var pattern = this.getAttribute("data-pattern");
			if (pattern) {
				var v = this.value;
				var message = "";
				if (v != "") {
					var f = format(this.value, pattern);
					if (f != null) {
						this.value = f;
					} else {
						message = this.getAttribute("data-pattern-message");
					}
				}
				if (this.setCustomValidity) {
					this.setCustomValidity(message);
				}
			}
		};
	});
};
